import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { ReusableButton } from 'gipsy-ui'
import { styles } from 'gipsy-misc'

export default class ImageButtons extends PureComponent {
  onNext = async () => {
    if (this.props.onNext()) {
      this.props.onNext()
    }
  }

  onSkip = () => {
    if (this.props.onSkip()) {
      this.props.onSkip()
    }
  }

  render() {
    const { nextButton, skipButton } = this.props

    return (
      <Container>
        <SkipButton
          width={200}
          height={56}
          textColor={styles.colors.textLightColor}
          backgroundColor={styles.colors.lightGrey}
          onClick={this.onSkip}>
          {skipButton}
        </SkipButton>
        <ReusableButton width={200} height={56} onClick={this.onNext}>
          {nextButton}
        </ReusableButton>
      </Container>
    )
  }
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
`

const SkipButton = styled(ReusableButton)`
  &:hover {
    background-color: ${styles.colors.darkGrey};
    .button-label {
      color: white;
    }
  }
`



// WEBPACK FOOTER //
// ./src/features/popup/components/onboardingButtons/ImageButtons.js